// extracted by mini-css-extract-plugin
export default {"group":"YCU0yxlhMA","left-group":"MPz22vmNRh","leftGroup":"MPz22vmNRh"};